// extracted by mini-css-extract-plugin
export var root = "M7-g";
export var rootBadge = "NNV0";
export var rootHiddenDesktop = "yX3J";
export var rootHiddenMobile = "bEVv";
export var rootIcon = "_7Nn1";
export var rootIconWrapper = "rZCX";
export var rootLabel = "OVuY";
export var rootcalculator = "ijyT";
export var rootreferral = "_4aOD";